import React from "react";
import { IoClose } from "react-icons/io5";
import { MdOutlineArchive } from "react-icons/md";

// The order lists' archived filter: "only" lists just the archived orders.
export const ARCHIVED_ONLY = "only";

export const isArchivedOnly = (filterValues) =>
  String(filterValues?.archived ?? "") === ARCHIVED_ONLY;

/**
 * The toolbar's Archived switch: on, the list shows only archived orders
 * (out of the list, their status unchanged), so they can be found and
 * brought back; clicking it again goes back to the list without them.
 */
const ArchivedToggle = ({ on, onChange }) => (
  <button
    type="button"
    aria-pressed={on}
    onClick={() => onChange(!on)}
    title={on ? "Back to the orders in the list" : "Show archived orders"}
    className={`flex items-center gap-[5px] whitespace-nowrap rounded-md border px-[13px] py-[5px] text-xs font-semibold transition-colors ${
      on
        ? "border-brand bg-brand-light text-brand"
        : "border-ui-border bg-ui-surface text-ui-text-muted hover:border-brand hover:bg-brand-light hover:text-brand"
    }`}
  >
    <MdOutlineArchive className="h-3 w-3 shrink-0" />
    Archived
    {on && (
      <IoClose aria-hidden="true" className="-mr-[3px] h-3 w-3 shrink-0" />
    )}
  </button>
);

export default ArchivedToggle;
